module.exports = __webpack_public_path__ + "officialStatic/img/product-jfrz.0d29e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-jfrz.png
// module id = UjZj
// module chunks = 0